// extracted by mini-css-extract-plugin
export default {"Wrapper":"styles_Wrapper__3NPMj","Header":"styles_Header__1Cxa9","Body":"styles_Body__GGYm4","MobileView":"styles_MobileView__hDQAV"};